export function feature_block() {
  if($('.feature-block .add-slider').length) {
    $('.feature-block .add-slider').each(function(index) {
      $(this).siblings('.nextArrow').addClass(`nextArrow-${index}`);
      $(this).siblings('.prevArrow').addClass(`prevArrow-${index}`);
      $(this).slick({
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(`.nextArrow-${index}`),
        nextArrow: $(`.prevArrow-${index}`),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              autoplay: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
          ]
        });
    });
  }
}
